import { render, staticRenderFns } from "./PartCkuMng.vue?vue&type=template&id=606dfe56&"
import script from "./PartCkuMng.vue?vue&type=script&lang=js&"
export * from "./PartCkuMng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports